import React from 'react';
import { LogoHeader } from '../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../Components/Inicio/NavDesktop';
import { NavMobile } from '../Components/Inicio/NavMobile';
import { LogInComponent } from '../Components/LogInComponent';
import { Footer } from '../Components/Footer/FooterComponent';

export const Login = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <LogInComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    );
};